import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Exactly what Monday's note will say, before it goes out.
export const DigestPreview = () => {
  const [note, setNote] = useState(null);
  const [busy, setBusy] = useState(false);

  const look = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/news/week-digest/preview");
      setNote(data);
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail) || "Could not put that note together");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        data-testid="week-digest-preview"
        onClick={look}
        disabled={busy}
        className="inline-flex min-h-[34px] items-center gap-1.5 rounded-full border border-white/10 px-3.5 text-xs text-ink-soft transition-colors hover:border-brand/40 hover:text-brand disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />}
        See my Monday note
      </button>

      <Dialog open={Boolean(note)} onOpenChange={(open) => (open ? null : setNote(null))}>
        <DialogContent className="max-w-2xl border-white/10 bg-panel" data-testid="digest-preview-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-lg" data-testid="digest-preview-subject">
              {note?.subject}
            </DialogTitle>
          </DialogHeader>
          <p className="text-xs text-ink-soft" data-testid="digest-preview-tally">
            {note?.listened} listened · {note?.read} read · {note?.minutes} min
            {note?.on === false ? " · switched off, so this one stays here" : " · lands Monday morning"}
          </p>
          <iframe
            title="Monday note"
            data-testid="digest-preview-frame"
            srcDoc={note?.html || ""}
            className="h-[460px] w-full rounded-2xl border border-white/10 bg-[#0A0A0B]"
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
